import { ProductsScreen } from "./products.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";
import { ProductEditRoutes } from "../product-edit";

export const ProductsRoutes: RouteDefinition[] = [
	{
		path: Paths.products.path,
		element: <ProductsScreen />,
		requiredPermissions: ["UserInAccountPermission_ProductAdmin_Read"],
	},
	...ProductEditRoutes,
];
